module.exports = __webpack_public_path__ + "static/media/protekt_black.f386b1d6.svg";